import Model from '@/models/Model'
import qs from 'qs'

export default class AccAccount extends Model {
    resource() {
        return 'acc_account'
    }

    get accountTypeCode() {
        if (!this.acc_account_type) return null
        return this.acc_account_type.code
    }

    get accountTypeComment() {
        if (!this.acc_account_type) return null
        return this.acc_account_type.comment
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get name() {
        return `${this.comment} - ${this.code}`
    }

    /**
     * 
     */
    get code_clean() {
        return this.code.split('.').join('')
    }

    /**
     * 
     */
    get code_int() {
        return parseInt(this.code_clean)
    }

    /**
     * 
     * @param {*} payload 
     */
    getExcel(params = {}) {
        return this.request({
            method: 'POST',
            data: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'brackets'})
            },
            responseType: 'blob',
            url: 'excel'.length > 0 ? this.fullURL().concat('/').concat('excel') : this.fullURL(),
        })
    }

    /**
     * 
     */
    getMovementAndBalance(payload) {

        //
        let accAccountClone = this.clone()

        //
        accAccountClone.id = 'movement_and_balance'

        //
        return accAccountClone.getExcel(payload).then(this.getMovementAndBalanceFile)
    }

    /**
     * 
     */
    getMovementAndBalanceFile = (res) => {

        //
        const name = res.request.getResponseHeader('content-disposition').split('filename=').pop()
        const filename = name.split('.xlsx').shift()

        //
        return this.showFile(name, 'xlsx')(res)
    }

    static includes = ['acc_account_type']
}
